import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Category from "../views/Category.vue";
import PlayListShow from "../views/PlayListShow.vue";
import i18n from "@/locales";
import { omit, startsWith } from "lodash";
import Cookies from "js-cookie";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:locale?",
    name: "Home",
    component: Home,
  },
  {
    path: "/:locale?/category/:slug",
    name: "Category",
    component: Category,
  },
  {
    path: "/:locale?/playlist_show",
    name: "playListShow",
    component: PlayListShow,
  },
  {
    path: "/*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { y: 0 };
  },
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  try {
    let locale = "en";
    if (to.params.locale === "es") {
      locale = "es";
    }
    let nextRoute = {};
    if (i18n.locale !== locale) {
      i18n.locale = locale;
      Cookies.set("locale", locale, {
        expires: 7,
        path: "/",
        sameSite: "None",
        secure: true,
      });
    }
    if (locale === "en" && startsWith(to.path, "/en")) {
      nextRoute = {
        ...to,
        params: {
          ...omit(to.params, "locale"),
        },
      };
      return router.replace({ name: to.name, ...nextRoute });
    }
    next();
  } catch (err) {
    console.error(err);
  }
});
export default router;
